<!-- version 2021/05/20 -->
<template>
  <span :class="{ 'text-overflow-ellipsis': ellipsis }" v-html="text"></span>
</template>

<script>
export default {
  props: {
    text: { type: String, default: '' },
    ellipsis: { type: Boolean, default: false },
  },
};
</script>

<style lang="sass" scoped>
span
  font-weight: 300
  color: #002832
  font-size: 16px
  white-space: pre-wrap
  &.text-overflow-ellipsis
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>
